import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HomeMolduleModel } from '../model/home/home.module.model';
import { HomeAlertasModel } from '../model/home/home.alertas.model';
import { HomeDescargaModel } from '../model/home/home.descarga.model';
import { HomePremioModel } from '../model/home/home.premio.model';
import { HomeAliadoModel } from '../model/home/home.aliado.model';
import { environment } from 'src/environments/environment';
import { ResponseMaintenance } from '../model/home/home.generic';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  private homeModules = 'assets/json/home/home-modules.json';
  private homeAlertas = 'assets/json/home/home-alertas.json';
  private homeDescargas = 'assets/json/home/home-descargas.json';
  private homePremios = 'assets/json/home/home-premios.json';
  private homeAliados = 'assets/json/home/home-aliados.json';

  private urlServiceAdmin = environment.API_SERVICES_ADMIN;
  private urlServiceGeo = environment.API_SERVICES_GEO;
  urlMaintenance = `${this.urlServiceAdmin}/api/maintenance`;
  urlNationalForest = `${this.urlServiceAdmin}/api/national-forest`;
  urlEvent = `${this.urlServiceAdmin}/api/event`;

  constructor(private http: HttpClient) {}

  getHomeModules() {
    return this.http.get<HomeMolduleModel>(this.homeModules);
  }

  getHomeModulesHttp(request: any) {
    return this.http.get<HomeMolduleModel>(
      `${this.urlMaintenance}?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}&maintenanceType=${request.type}`
    );
  }

  getHomeEstadisticas(request: any) {
    return this.http.get<ResponseMaintenance[]>(
      `${this.urlMaintenance}?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}&maintenanceType=${request.type}`
    );
  }

  getPremiosCertificaciones(request: any) {
    return this.http.get<ResponseMaintenance[]>(
      `${this.urlMaintenance}/maintenance/maintenance-list?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}&maintenanceType=${request.type}`
    );
  }

  getDescargasDestacadas(request: any) {
    return this.http.get<ResponseMaintenance[]>(
      `${this.urlMaintenance}/maintenance/featured-download?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}`
    );
  }

  getAlertas() {
    return this.http.get<HomeAlertasModel>(this.homeAlertas);
  }

  getDescargas() {
    return this.http.get<HomeDescargaModel>(this.homeDescargas);
  }

  getPremios() {
    return this.http.get<HomePremioModel[]>(this.homePremios);
  }

  getAliados() {
    return this.http.get<HomeAliadoModel[]>(this.homeAliados);
  }

  postEvent(body: { registerType: number; downloadId: number }) {
    return this.http.post<any>(this.urlEvent,body);
  }
}
